import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/Footer_Corporate/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/Header/HeaderCheckout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/PreviewBar/PreviewBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/StartChat/StartChat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/ui/AnchorLink/AnchorLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/components/Wrappers/Main.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/context/ModalsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/context/TemplateContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/context/UTMParametersContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2204388031/src/damac-digital/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2204388031/src/damac-digital/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2204388031/src/damac-digital/node_modules/next/dist/client/script.js");
